/*
 * Capable Health API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0.3
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.72
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';
import SurveyssubmissionsSubmission from './SurveyssubmissionsSubmission';

/**
 * The SurveysSubmissionsBody model module.
 * @module model/SurveysSubmissionsBody
 * @version v0.3
 */
export default class SurveysSubmissionsBody {
  /**
   * Constructs a new <code>SurveysSubmissionsBody</code>.
   * @alias module:model/SurveysSubmissionsBody
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>SurveysSubmissionsBody</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/SurveysSubmissionsBody} obj Optional instance to populate.
   * @return {module:model/SurveysSubmissionsBody} The populated <code>SurveysSubmissionsBody</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new SurveysSubmissionsBody();
      if (data.hasOwnProperty('submission'))
        obj.submission = SurveyssubmissionsSubmission.constructFromObject(data['submission']);
    }
    return obj;
  }
}

/**
 * @member {module:model/SurveyssubmissionsSubmission} submission
 */
SurveysSubmissionsBody.prototype.submission = undefined;

